export const CloseButtonIcon = (props: { onClick: Function }) => {
  return (
    <span className="pimaco-icons" onClick={() => props.onClick()}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.7 25.7">
        <path
          d="M25.7.7L25 0 12.9 12.1.7 0 0 .7l12.1 12.2L0 25l.7.7 12.2-12.1L25 25.7l.7-.7-12.1-12.1z"
          fill="#010101"
        />
      </svg>
    </span>
  );
};

export const MenuButtonIcon = (props: { onClick: Function }) => {
  return (
    <span className="pimaco-icons" onClick={() => props.onClick()}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -3 25.7 25.7" fill="#020203">
        <path d="M0 0h30.5v1.72H0zm0 8.71h30.5v1.72H0zm0 8.71h30.5v1.72H0z" />
      </svg>
    </span>
  );
};

export const LanguageButtonIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.5 18.5">
      <path d="M9.2 0C4.1 0 0 4.1 0 9.2s4.1 9.2 9.2 9.2 9.2-4.1 9.2-9.2C18.5 4.1 14.3 0 9.2 0zm0 17.3c-1.4 0-2.7-1.9-3.3-4.5h6.5c-.5 2.6-1.7 4.5-3.2 4.5zm-3.4-5.6c-.1-.8-.2-1.6-.2-2.5s.1-1.7.2-2.5h6.9c.1.8.2 1.6.2 2.5s-.1 1.7-.2 2.5H5.8zM9.2 1.2c1.4 0 2.7 1.9 3.3 4.5H6c.6-2.6 1.8-4.5 3.2-4.5zm4.5 5.6h3.4c.2.8.4 1.6.4 2.5s-.1 1.7-.4 2.5h-3.4c.1-.8.2-1.6.2-2.5 0-.9-.1-1.8-.2-2.5zm3-1h-3.2c-.4-1.9-1.1-3.5-2-4.4 2.3.6 4.2 2.2 5.2 4.4zM7 1.3c-.9 1-1.6 2.5-2 4.4H1.8C2.8 3.6 4.7 2 7 1.3zM1.4 6.8h3.4c-.1.7-.2 1.6-.2 2.4 0 .9.1 1.7.2 2.5H1.4c-.3-.8-.4-1.6-.4-2.5s.1-1.7.4-2.4zm.4 5.9H5c.4 1.9 1.1 3.5 2 4.4-2.3-.6-4.2-2.2-5.2-4.4zm9.7 4.5c.9-1 1.6-2.5 2-4.4h3.2c-1 2.1-2.9 3.7-5.2 4.4z" />
    </svg>
  );
};

export const WhatsappButtonIcon = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 59 59.5"
      className="whatsapp-icon"
    >
      <g>
        <path
          className="st0"
          d="M30.8,0C15.3,0,2.7,12.6,2.7,28.1c0,5.6,2.1,10.7,3.3,13.1L0,59.5l18.6-6c2.2,1,6.7,2.8,12.2,2.8
                    C46.3,56.3,59,43.6,59,28.1S46.3,0,30.8,0z"
        />
        <g>
          <path
            className="st1"
            d="M30.8,3.5c-13.6,0-24.6,11-24.6,24.6c0,6.8,3.6,12.8,3.6,12.8L5.5,54L19,49.7c0,0,5,3,11.9,3
                        c13.6,0,24.6-11,24.6-24.6S44.4,3.5,30.8,3.5z M30.8,48.8c-6.3,0-11.4-3.4-11.4-3.4l-7.8,2.5l2.5-7.5c0,0-4-5.6-4-12.3
                        c0-11.4,9.3-20.7,20.7-20.7c11.4,0,20.7,9.3,20.7,20.7S42.3,48.8,30.8,48.8z"
          />
          <path
            className="st1"
            d="M42.9,33.3c0,0-4-2-4.9-2.3c-0.8-0.4-1.3,0.2-1.3,0.2s-1.2,1.5-1.6,2.1c-0.4,0.5-0.6,1-1.6,0.6
                        c-1-0.3-3.1-1.4-4.8-3s-3-3.5-3.3-4.1c-0.4-0.6,0.1-1,0.1-1s1.1-1.2,1.6-1.9c0.5-0.7,0.2-1.4,0.1-1.7s-1.8-4.1-2-4.7
                        S24.4,17,24.4,17s-1.6,0-1.9,0s-1,0.4-1,0.4c-2,1.3-2.3,4.3-2.4,4.9c-0.1,0.6-0.1,2,0.9,4.3c1.1,2.3,3.6,5.4,6.8,8.4
                        c3.2,3,8,4.2,9.5,4.6c1.5,0.4,4.6-0.3,6-1.9c1.5-1.6,1.1-3.2,1.1-3.8C43.4,33.4,42.9,33.3,42.9,33.3z"
          />
        </g>
      </g>
    </svg>
  );
};

export const ParametroImpressaoIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 133.1 189" fill="#010101">
      <path d="M107 0H0v189h133.1V26.2L107 0zm.5 3.4l22 22.1h-22V3.4zM2 187V2h103.5v13.3H16.8v2h88.8v5.5H16.8v2h88.8v2.7h25.5V187H2zM16.8 30.3h99v2h-99zm0 7.4h99v2h-99zm-.1 134.6h99v-127h-99v127zm2-5.8h16.8v3.8H18.7v-3.8zM75.1 62v5.5H57.3V62h17.8zm-17.8-2v-5.5h17.8V60H57.3zm0 97v-5.5h17.8v5.5H57.3zm17.8 2v5.5H57.3V159h17.8zm0-82.1v5.5H57.3v-5.5h17.8zm-17.8-2v-5.5h17.8v5.5H57.3zm17.8 9.5v5.5H57.3v-5.5h17.8zm0 7.5v5.5H57.3v-5.5h17.8zm0 7.4v5.5H57.3v-5.5h17.8zm0 7.5v5.5H57.3v-5.5h17.8zm0 7.5v5.5H57.3v-5.5h17.8zm0 7.4v5.5H57.3v-5.5h17.8zm0 7.5v5.5H57.3v-5.5h17.8zm0 7.4v5.5H57.3v-5.5h17.8zm0 7.5v5.5H57.3v-5.5h17.8zm2 7.5H95v5.5H77.1v-5.5zm0-2v-5.5H95v5.5H77.1zm0-7.5v-5.5H95v5.5H77.1zm0-7.5v-5.5H95v5.5H77.1zm0-7.4v-5.5H95v5.5H77.1zm0-7.5v-5.5H95v5.5H77.1zm0-7.4v-5.5H95v5.5H77.1zm0-7.5v-5.5H95v5.5H77.1zm0-7.5v-5.5H95v5.5H77.1zm0-7.4v-5.5H95v5.5H77.1zm0-7.5v-5.5H95v5.5H77.1zm0-7.5v-5.5H95v5.5H77.1zm0-7.4V62H95v5.5H77.1zm-21.8 0H37.5V62h17.8v5.5zm0 2V75H37.5v-5.5h17.8zm0 7.4v5.5H37.5v-5.5h17.8zm0 7.5v5.5H37.5v-5.5h17.8zm0 7.5v5.5H37.5v-5.5h17.8zm0 7.4v5.5H37.5v-5.5h17.8zm0 7.5v5.5H37.5v-5.5h17.8zm0 7.5v5.5H37.5v-5.5h17.8zm0 7.4v5.5H37.5v-5.5h17.8zm0 7.5v5.5H37.5v-5.5h17.8zm0 7.4v5.5H37.5v-5.5h17.8zm0 7.5v5.5H37.5v-5.5h17.8zm0 7.5v5.5H37.5v-5.5h17.8zm0 7.4v5.5H37.5V159h17.8zm0 7.5v3.8H37.5v-3.8h17.8zm2 0h17.8v3.8H57.3v-3.8zm19.8 0H95v3.8H77.1v-3.8zm0-2V159H95v5.5H77.1zM97 159h16.8v5.5H97V159zm0-2v-5.5h16.8v5.5H97zm0-7.4v-5.5h16.8v5.5H97zm0-7.5v-5.5h16.8v5.5H97zm0-7.5v-5.5h16.8v5.5H97zm0-7.4v-5.5h16.8v5.5H97zm0-7.5v-5.5h16.8v5.5H97zm0-7.4v-5.5h16.8v5.5H97zm0-7.5v-5.5h16.8v5.5H97zm0-7.5v-5.5h16.8v5.5H97zm0-7.4v-5.5h16.8v5.5H97zm0-7.5v-5.5h16.8v5.5H97zm0-7.5v-5.5h16.8v5.5H97zm0-7.4V62h16.8v5.5H97zm0-7.5v-5.5h16.8V60H97zm-2 0H77.1v-5.5H95V60zm-17.9-7.4v-5.2H95v5.2H77.1zm-2 0H57.3v-5.2h17.8v5.2zm-19.8 0H37.5v-5.2h17.8v5.2zm0 2V60H37.5v-5.5h17.8zM35.5 60H18.7v-5.5h16.8V60zm0 2v5.5H18.7V62h16.8zm0 7.5V75H18.7v-5.5h16.8zm0 7.4v5.5H18.7v-5.5h16.8zm0 7.5v5.5H18.7v-5.5h16.8zm0 7.5v5.5H18.7v-5.5h16.8zm0 7.4v5.5H18.7v-5.5h16.8zm0 7.5v5.5H18.7v-5.5h16.8zm0 7.5v5.5H18.7v-5.5h16.8zm0 7.4v5.5H18.7v-5.5h16.8zm0 7.5v5.5H18.7v-5.5h16.8zm0 7.4v5.5H18.7v-5.5h16.8zm0 7.5v5.5H18.7v-5.5h16.8zm0 7.5v5.5H18.7v-5.5h16.8zm0 7.4v5.5H18.7V159h16.8zM97 170.3v-3.8h16.8v3.8H97zm16.7-117.7H97v-5.2h16.8v5.2zm-78.2-5.3v5.2H18.7v-5.2h16.8z" />
    </svg>
  );
};

export const GabaritoCDpplyIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 178.2 252" fill="#010101">
      <path d="M61.7 108.8c-26.2 0-47.4-21.3-47.4-47.4C14.3 35.2 35.6 14 61.7 14c26.2 0 47.4 21.3 47.4 47.4s-21.2 47.4-47.4 47.4zm0-92.9c-25 0-45.4 20.4-45.4 45.4s20.4 45.4 45.4 45.4c25.1 0 45.4-20.4 45.4-45.4S86.8 15.9 61.7 15.9zm0 59c-7.4 0-13.5-6.1-13.5-13.5s6.1-13.5 13.5-13.5S75.2 54 75.2 61.4s-6 13.5-13.5 13.5zm0-25c-6.3 0-11.5 5.2-11.5 11.5s5.2 11.5 11.5 11.5 11.5-5.2 11.5-11.5c0-6.4-5.1-11.5-11.5-11.5zm59.4 58.9H112V13.9h9.1v94.9zm-7.2-2h5.1V15.9h-5.1v90.9zm51.2 2h-42.5V13.9h42.5v94.9zm-40.5-2h38.5V15.9h-38.5v90.9zm-6.9 131.3c-26.2 0-47.4-21.3-47.4-47.4s21.3-47.4 47.4-47.4c26.2 0 47.4 21.3 47.4 47.4s-21.3 47.4-47.4 47.4zm0-92.8c-25 0-45.4 20.4-45.4 45.4s20.4 45.4 45.4 45.4 45.4-20.4 45.4-45.4-20.4-45.4-45.4-45.4zm0 58.9c-7.4 0-13.5-6.1-13.5-13.5s6.1-13.5 13.5-13.5 13.5 6.1 13.5 13.5-6.1 13.5-13.5 13.5zm0-25c-6.3 0-11.5 5.2-11.5 11.5s5.2 11.5 11.5 11.5 11.5-5.2 11.5-11.5-5.2-11.5-11.5-11.5zm-50.2 58.9h-9.1v-94.9h9.1v94.9zm-7.2-2h5.1v-90.9h-5.1v90.9zm-3.5 2H14.3v-94.9h42.5v94.9zm-40.5-2h38.5v-90.9H16.3v90.9zM178.2 252H0V0h178.2v252zM2 250h174.2V2H2v248z" />
    </svg>
  );
};

export const GabaritoCasaArtesanatoIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 193.3 250">
      <path
        d="M92.8 10.8v109.7H17.2V10.8h75.6m.2-2H17a1.79 1.79 0 0 0-1.8 1.8v110.1a1.79 1.79 0 0 0 1.8 1.8h76a1.79 1.79 0 0 0 1.8-1.8V10.6A1.79 1.79 0 0 0 93 8.8h0zm83.1 2v109.7h-75.6V10.8h75.6m.1-2h-76a1.79 1.79 0 0 0-1.8 1.8v110.1a1.79 1.79 0 0 0 1.8 1.8h76a1.79 1.79 0 0 0 1.8-1.8V10.6c.1-1-.8-1.8-1.8-1.8h0zM92.8 128.1v109.7H17.2V128.1h75.6m.2-2H17a1.79 1.79 0 0 0-1.8 1.8V238a1.79 1.79 0 0 0 1.8 1.8h76a1.79 1.79 0 0 0 1.8-1.8V127.9a1.79 1.79 0 0 0-1.8-1.8h0zm83.1 2v109.7h-75.6V128.1h75.6m.1-2h-76a1.79 1.79 0 0 0-1.8 1.8V238a1.79 1.79 0 0 0 1.8 1.8h76a1.79 1.79 0 0 0 1.8-1.8V127.9c.1-1-.8-1.8-1.8-1.8h0z"
        fill="#010101"
      />
      <path
        d="M0 0h193.3v250H0z"
        fill="none"
        stroke="#010101"
        stroke-width="2"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export const GabaritoInkjetLaserIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 195.2 252" fill="#010101">
      <path d="M93.8 16.4v49.8H18.2V16.4h75.6m.7-2H17.4c-.7 0-1.2.5-1.2 1.2V67c0 .7.5 1.2 1.2 1.2h77.1c.7 0 1.2-.5 1.2-1.2V15.7c.1-.7-.5-1.3-1.2-1.3h0zm82.4 2v49.8h-75.5V16.4h75.5m.8-2h-77.1c-.7 0-1.2.5-1.2 1.2V67c0 .7.5 1.2 1.2 1.2h77.1c.7 0 1.2-.5 1.2-1.2V15.7c0-.7-.6-1.3-1.2-1.3h0zM93.8 72.8v49.8H18.2V72.8h75.6m.7-2H17.4c-.7 0-1.2.5-1.2 1.2v51.3c0 .7.5 1.2 1.2 1.2h77.1c.7 0 1.2-.5 1.2-1.2V72c.1-.6-.5-1.2-1.2-1.2h0zm82.4 2v49.8h-75.5V72.8h75.5m.8-2h-77.1c-.7 0-1.2.5-1.2 1.2v51.3c0 .7.5 1.2 1.2 1.2h77.1c.7 0 1.2-.5 1.2-1.2V72c0-.6-.6-1.2-1.2-1.2h0zm-83.9 58.4V179H18.2v-49.8h75.6m.7-2H17.4c-.7 0-1.2.5-1.2 1.2v51.3c0 .7.5 1.2 1.2 1.2h77.1c.7 0 1.2-.5 1.2-1.2v-51.3c.1-.7-.5-1.2-1.2-1.2h0zm82.4 2V179h-75.5v-49.8h75.5m.8-2h-77.1c-.7 0-1.2.5-1.2 1.2v51.3c0 .7.5 1.2 1.2 1.2h77.1c.7 0 1.2-.5 1.2-1.2v-51.3c0-.7-.6-1.2-1.2-1.2h0zm-83.9 58.4v49.8H18.2v-49.8h75.6m.7-2H17.4c-.7 0-1.2.5-1.2 1.2v51.3c0 .7.5 1.2 1.2 1.2h77.1c.7 0 1.2-.5 1.2-1.2v-51.3c.1-.7-.5-1.2-1.2-1.2h0zm82.4 2v49.8h-75.5v-49.8h75.5m.8-2h-77.1c-.7 0-1.2.5-1.2 1.2v51.3c0 .7.5 1.2 1.2 1.2h77.1c.7 0 1.2-.5 1.2-1.2v-51.3c0-.7-.6-1.2-1.2-1.2h0zm17.5 68.4H0V0h195.2v252zM2 250h191.2V2H2v248z" />
    </svg>
  );
};

export const GabaritoPimatabIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 195.3 252">
      <g fill="#010101">
        <path d="M64.8 16.4v37.7H12V16.4h52.8m1.1-2h-55c-.5 0-1 .4-1 1v39.8c0 .5.4 1 1 1h55c.5 0 1-.4 1-1V15.4c-.1-.6-.5-1-1-1h0zm57.6 2V54H70.6V16.4h52.9m1-2h-55c-.5 0-.9.4-.9.9V55c0 .5.4.9.9.9h55c.5 0 .9-.4.9-.9V15.4c.1-.6-.3-1-.9-1h0zm57.6 2V54h-52.9V16.4h52.9m1.1-2h-55c-.5 0-.9.4-.9.9V55c0 .5.4.9.9.9h55c.5 0 .9-.4.9-.9V15.4c0-.6-.4-1-.9-1h0zM64.8 61.7v37.7H12V61.7h52.8m1.1-2h-55c-.5 0-1 .4-1 1v39.8c0 .5.4 1 1 1h55c.5 0 1-.4 1-1V60.7c-.1-.5-.5-1-1-1h0zm57.6 2v37.6H70.6V61.7h52.9m1-2h-55c-.5 0-.9.4-.9.9v39.7c0 .5.4.9.9.9h55c.5 0 .9-.4.9-.9V60.7c.1-.5-.3-1-.9-1h0zm57.6 2v37.6h-52.9V61.7h52.9m1.1-2h-55c-.5 0-.9.4-.9.9v39.7c0 .5.4.9.9.9h55c.5 0 .9-.4.9-.9V60.7c0-.5-.4-1-.9-1h0zM64.8 107.1v37.7H12v-37.7h52.8m1.1-2h-55c-.5 0-1 .4-1 1v39.8c0 .5.4 1 1 1h55c.5 0 1-.4 1-1V106c-.1-.5-.5-.9-1-.9h0zm57.6 2v37.6H70.6v-37.6h52.9m1-2h-55c-.5 0-.9.4-.9.9v39.7c0 .5.4.9.9.9h55c.5 0 .9-.4.9-.9V106c.1-.5-.3-.9-.9-.9h0zm57.6 2v37.6h-52.9v-37.6h52.9m1.1-2h-55c-.5 0-.9.4-.9.9v39.7c0 .5.4.9.9.9h55c.5 0 .9-.4.9-.9V106c0-.5-.4-.9-.9-.9h0z" />
        <use />
        <path d="M123.5 152.4V190H70.6v-37.6h52.9m1-2h-55c-.5 0-.9.4-.9.9V191c0 .5.4.9.9.9h55c.5 0 .9-.4.9-.9v-39.7c.1-.5-.3-.9-.9-.9h0zm57.6 2V190h-52.9v-37.6h52.9m1.1-2h-55c-.5 0-.9.4-.9.9V191c0 .5.4.9.9.9h55c.5 0 .9-.4.9-.9v-39.7c0-.5-.4-.9-.9-.9h0z" />
        <use y="45.3" />
        <path d="M123.5 197.7v37.6H70.6v-37.6h52.9m1-2h-55c-.5 0-.9.4-.9.9v39.7c0 .5.4.9.9.9h55c.5 0 .9-.4.9-.9v-39.7c.1-.5-.3-.9-.9-.9h0zm57.6 2v37.6h-52.9v-37.6h52.9m1.1-2h-55c-.5 0-.9.4-.9.9v39.7c0 .5.4.9.9.9h55c.5 0 .9-.4.9-.9v-39.7c0-.5-.4-.9-.9-.9h0zm12.1 56.3H0V0h195.3v252zM2 250h191.3V2H2v248z" />
      </g>
      <defs>
        <path
          id="B"
          d="M64.8 152.4v37.7H12v-37.7h52.8m1.1-2h-55c-.5 0-1 .4-1 1v39.8c0 .5.4 1 1 1h55c.5 0 1-.4 1-1v-39.8c-.1-.6-.5-1-1-1h0z"
        />
      </defs>
    </svg>
  );
};

export const GabaritoFotografiaIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 252 178.8" fill="#010101">
      <path d="M0 0v178.8h252V0H0zm250 176.8H2V2h248v174.8zm-225.3-3.5h202.5c2.6 0 4.8-2.1 4.8-4.8V10.3c0-2.6-2.1-4.8-4.8-4.8H24.7c-2.6 0-4.8 2.1-4.8 4.8v158.3c.1 2.6 2.2 4.7 4.8 4.7zM22 10.3c0-1.5 1.2-2.8 2.8-2.8h202.5c1.5 0 2.8 1.2 2.8 2.8v158.3c0 1.5-1.2 2.8-2.8 2.8H24.7c-1.5 0-2.8-1.2-2.8-2.8V10.3z" />
    </svg>
  );
};

export const GabaritoCartaoVisitaIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 195.1 252" fill="#333">
      <path d="M177 12h.2v227.4h-.2z" />
      <path d="M176 11h2.2v229.4H176zm-78.6 1h.2v227.4h-.2z" />
      <path d="M96.4 11h2.2v229.4h-2.2zm-78.6 1h.2v227.4h-.2z" />
      <path d="M16.8 11H19v229.4h-2.2z" />
      <path d="M17.9 239.3H177v.2H17.9z" />
      <path d="M16.9 238.3H178v2.2H16.9zm1-44.4H177v.2H17.9z" />
      <path d="M16.9 192.9H178v2.2H16.9zm1-44.5H177v.2H17.9z" />
      <path d="M16.9 147.4H178v2.2H16.9zm1-44.4H177v.2H17.9z" />
      <path d="M16.9 102H178v2.2H16.9zm1-44.5H177v.2H17.9z" />
      <path d="M16.9 56.5H178v2.2H16.9zm1-44.5H177v.2H17.9z" />
      <path d="M16.9 11H178v2.2H16.9zm178.2 241H0V0h195.1v252zM2 250h191.1V2H2v248z" />
    </svg>
  );
};

export const GabaritoEscritorioEscolarIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 251.7 179.9" fill="#010101">
      <path d="M231.7 166.2h-87.8c-2.6 0-4.7-2.1-4.7-4.7V20.3c0-2.6 2.1-4.7 4.7-4.7h87.8c2.6 0 4.7 2.1 4.7 4.7v141.3c0 2.6-2.1 4.6-4.7 4.6zM143.9 17.6a2.69 2.69 0 0 0-2.7 2.7v141.3a2.69 2.69 0 0 0 2.7 2.7h87.8a2.69 2.69 0 0 0 2.7-2.7V20.3a2.69 2.69 0 0 0-2.7-2.7h-87.8zM125.1 0h1v179.9h-1z" />
      <path d="M251.7 179.5H0V1.6h251.7v177.9zM2 177.5h247.7V3.6H2v173.9z" />
    </svg>
  );
};

export const SearchButtonIcon = (props: { onClick?: Function }) => {
  return (
    <span className="pimaco-icons" onClick={() => (props.onClick ? props.onClick() : undefined)}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.8 22">
        <path
          d="M21.8,21.3l-6.3-6.3c1.5-1.6,2.4-3.7,2.4-6c0-4.9-4-8.9-8.9-8.9C4,0,0,4,0,8.9s4,8.9,8.9,8.9  c2.2,0,4.3-0.8,5.8-2.2l6.3,6.3L21.8,21.3z M1,8.9C1,4.5,4.5,1,8.9,1s7.9,3.5,7.9,7.9c0,4.4-3.5,7.9-7.9,7.9S1,13.3,1,8.9z"
          fill="#010101"
        />
      </svg>
    </span>
  );
};

export const UploadButtonIcon = () => {
  return (
    <span className="pimaco-icons upload-icon">
      <svg
        version="1.1"
        id="Camada_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 180 123.33"
      >
        <g>
          <g>
            <polyline className="st0" points="108.37,42.61 101.22,42.61 101.22,35.46 		" />
            <polygon
              className="st0"
              points="108.37,42.63 108.37,87.87 71.63,87.87 71.63,35.46 101.23,35.46 		"
            />
          </g>

          <polyline className="st0" points="96.21,53.68 89.82,47.29 83.44,53.68 	" />
          <line className="st1" x1="89.64" y1="75.79" x2="89.64" y2="51.36" />
        </g>
      </svg>
    </span>
  );
};

export const ArrowButtonIcon = (props: { onClick: Function }) => {
  return (
    <span className="pimaco-icons" onClick={() => props.onClick()}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="4 -7 20 20">
        <path
          d="m 0 0 l 12.92 9.93 l 14.1 -9.93"
          fill="none"
          stroke="#020203"
          strokeWidth=".8"
          strokeMiterlimit="10"
        />
      </svg>
    </span>
  );
};
